import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    timeout: 20000,
});

const TOKEN_KEY = "rks_admin_token";

export function getAdminToken() {
    try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}

export function setAdminToken(token) {
    try {
        if (token) localStorage.setItem(TOKEN_KEY, token);
        else localStorage.removeItem(TOKEN_KEY);
    } catch { /* ignore */ }
}

api.interceptors.request.use((config) => {
    const t = getAdminToken();
    if (t && config.url?.includes("/admin")) {
        config.headers.Authorization = `Bearer ${t}`;
    } else if (t && (config.url?.endsWith("/auth/me") || config.url?.endsWith("/auth/logout"))) {
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
